import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../../theme-constants/colors';




export const searchPageStyles = makeStyles((theme) => ({
    searchFilters: {
        [theme.breakpoints.up('lg')]: {
            paddingRight: theme.spacing(2),
        },
        '& .filters': {
            '&-header': {
                marginBottom: theme.spacing(1.5),
                [theme.breakpoints.down('sm')]: {
                    marginBottom: theme.spacing(1),
                },
            },
            '&-group': {
                marginBottom: theme.spacing(1.25),
            },
            '&-chips': {
                width: '100%',
                '&-header': {
                    marginBottom: theme.spacing(.5),
                },
                '&-item': {
                    [theme.breakpoints.down('md')]: {
                        display: 'inline-block',
                        marginRight: theme.spacing(.5),
                    },
                },
                '& .MuiChip': {
                    '&-label': {
                        whiteSpace:'normal',
                    },
                    '&-root': {
                        marginBottom: theme.spacing(.5),
                        height: 'auto',

                    },
                    '&-deleteIcon': {
                        fill: tcsmColors.blue,
                    },
                },
            },
            '&-tablet-columns': {
                width: '100%',
                [theme.breakpoints.between('sm', 'md')]: {
                    display: 'flex',
                    justifyContent: 'space-between',
                },

                '&-item': {
                    [theme.breakpoints.between('sm', 'md')]: {
                        width: 'calc(50% - 2rem)',
                    },
                },
            },
        },
        '& .row-header-text, & .row-tooltip': {
            paddingRight: theme.spacing(2),
        },
        

    },
    searchBar: {
        marginBottom: theme.spacing(1),
        '& .MuiFormControl-root, & .MuiInputBase-root ': {
            display: 'block',
            width: '100%',
        },
        '& .search-field': {
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            '&-actions': {
                display: 'flex',
                position: 'absolute',
                marginRight: '0.5rem',
                right: '0',
                top: '5px', /// overrides fieldset
                '& svg': {
                    height: '1.25rem',
                    width: '1.25rem',
                    fill: tcsmColors.blue,
                },
            },
            '& input': {
                margin: '0',
            },
        },
    },



}));
